import {SELECT_TYPE} from './FileTypeResource';

export const otherFileTypeResource = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    }
];